var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('ik-data-table',{ref:"table",attrs:{"model":_vm.model,"use-default-action":false,"entity-name":"奖励进度","icon":"mdi-cash-usd"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }